<script lang="ts">
  import News from '$lib/components/news/News.svelte';
</script>

<svelte:head>
  <title>ORF Archiv</title>
</svelte:head>

<News />
